import { ElementRef, Injectable, NgZone } from '@angular/core';
import { ViewportRuler } from '@angular/cdk/overlay';
import { BehaviorSubject, Observable, Subject, Subscriber, Subscription } from 'rxjs';
import { distinctUntilChanged, map, startWith } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ElementObserverService {

    private subscriptions: Subject<number>[] = [];
    private viewportSubscription: Subscription;

    constructor(private viewportRuler: ViewportRuler, private zone: NgZone) {
        this.viewportSubscription = this.viewportRuler.change(1000).subscribe(
            () => this.zone.run(() => {
                this.subscriptions.forEach((subscription) => subscription.next(0));
            })
        );
    }

    public observeWidth(elem: ElementRef): Observable<number> {
        const subject = new Subject<number>();
        this.subscriptions.push(subject);
        return subject.pipe(
            startWith(0),
            map(() => elem.nativeElement.clientWidth)
        );
    }

}
